import React from 'react'
import styled from 'styled-components/macro'
import {createSelectableContext} from "../../hooks/useSignalUpdate";

styled
export const [UIDataProvider,useUIDataSelector] = createSelectableContext()